import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchMeta } from '@/api/meta';
import type { Meta } from '@/api/types';

// 부트스트랩에서 한 번 호출. Layout이 root에 위치시켜 모든 페이지가 공유.
export function useMeta(): AsyncState<Meta> {
  return useFetch<Meta>((signal) => fetchMeta(signal), []);
}
